import { useEffect, useState } from "react";
import api from "../api";
import { Modal } from "./ui";

export default function EmailHealth({ onClose }) {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () => api.get("/contacts-health/check", { noCache: true }).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const fix = async (row, email) => {
    const val = email || window.prompt(`Nuova email per ${row.name}:`, row.email);
    if (!val) return;
    setBusy(row.id);
    try {
      const r = await api.post("/contacts-health/fix", { source: row.source, id: row.id, new_email: val });
      if (r.data.consensi_aggiornati) console.log("consensi aggiornati:", r.data.consensi_aggiornati);
      load();
    } catch (e) { alert(e.response?.data?.detail || e.message); }
    setBusy("");
  };
  const suppress = async (row) => {
    if (!window.confirm(`Escludere ${row.email} da tutti gli invii futuri?`)) return;
    setBusy(row.id);
    try { await api.post("/contacts-health/suppress", { source: row.source, id: row.id, new_email: row.email }); load(); }
    catch (e) { alert(e.response?.data?.detail || e.message); }
    setBusy("");
  };

  return (
    <Modal title="🩺 Controllo email anagrafica" onClose={onClose} wide>
      {rows === null ? <p>Scansione in corso…</p> : rows.length === 0 ? (
        <p data-testid="health-empty">✅ Nessuna email sospetta trovata: tutti gli indirizzi sembrano validi.</p>
      ) : (
        <>
          <p className="muted" style={{ marginTop: 0, fontSize: 13 }}>
            {rows.length} indirizzi sospetti. "✔ Correggi" applica il suggerimento (e aggiorna anche la lista consensi);
            "🚫 Escludi" blocca gli invii futuri verso quell'indirizzo.
          </p>
          <table style={{ fontSize: 13 }} data-testid="health-table">
            <thead><tr><th>Contatto</th><th>Email attuale</th><th>Problema</th><th>Suggerita</th><th></th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={`${r.source}-${r.id}`}>
                  <td>{r.name} <span className="muted" style={{ fontSize: 11 }}>({r.source})</span></td>
                  <td style={{ color: "#f87171", wordBreak: "break-all" }}>{r.email}</td>
                  <td>{r.problema}</td>
                  <td style={{ color: "#6ee7b7", wordBreak: "break-all" }}>{r.suggerimento || "—"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {r.suggerimento && <button className="btn sm primary" disabled={busy === r.id} onClick={() => fix(r, r.suggerimento)} data-testid={`health-fix-${r.id}`}>✔ Correggi</button>}
                    <button className="btn sm" style={{ marginLeft: 4 }} disabled={busy === r.id} onClick={() => fix(r, null)} data-testid={`health-edit-${r.id}`}>✏️</button>
                    <button className="btn sm danger" style={{ marginLeft: 4 }} disabled={busy === r.id} onClick={() => suppress(r)} data-testid={`health-suppress-${r.id}`}>🚫</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </Modal>
  );
}
